import { flow } from 'fp-ts/function';
import type { TextNode } from 'parse5';

import type { Rule } from '../core/models';
import type { Interceptor } from '../core/parser';
import parse from '../core/parser';
import {
  aToAnchor,
  aToLink,
  backgroundStyleToTextHighlight,
  colorStyleToTextColor,
  hToHeading,
  lToList,
  pToParagraph,
  spanToMention,
  spanToSpoiler,
  strongEmUToDecoration,
  textToText,
} from '../core/rules';
import { preprocess } from './preprocess';

const noEmptyLineText: Rule = [
  node => textToText[0](node) && (node as TextNode).value !== '\n',
  textToText[1],
];

export const fromRichTextHtml = (s: string, interceptor: Interceptor = ({ result }) => result) =>
  flow(
    () => preprocess(s),
    parse(
      [
        noEmptyLineText,
        pToParagraph,
        lToList,
        hToHeading,
        aToLink,
        aToAnchor,
        strongEmUToDecoration,
        colorStyleToTextColor,
        spanToMention,
        spanToSpoiler,
        backgroundStyleToTextHighlight,
      ],
      interceptor
    )
  )();

export type { Interceptor };
